<template>
  <div id="app">
    <router-view ref="pageHeader" />
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex';
export default {
  name: 'app',
  data() {
    return {
      isWs: true,
      count: 0,
      timeOutNum: null, // 定时器
    }
  },
  created() {
    // this.localSocket();
    // this.reconnect();
  },
  mounted() {
    this.menu_height();
    window.addEventListener('resize', this.menu_height.bind(this));
  },
  methods: {
    ...mapActions('main', ['set_menu_height']),
    // localSocket() {
    //   let that = this;
    //   let url = "";
    //   let wsuri = "";
    //   if (that.baseUrl3.indexOf('https://') != -1) {
    //     url = that.baseUrl3.split('https://')[1];
    //     wsuri = "wss://" + url + "instance";
    //   } else {
    //     url = that.baseUrl3.split('http://')[1];
    //     //初始化weosocket
    //     wsuri = "ws://" + url + "instance";
    //   }

    //   if ('WebSocket' in window) {
    //     console.log('您的浏览器支持 WebSocket!');
    //     that.ws = new WebSocket(wsuri);
    //     that.websocket.setWs(that.ws);
    //     that.ws.onopen = function () {
    //       that.websocket.connectState = true;
    //       console.log('连接成功');
    //       that.count = 0;

    //     };
    //     //that.onopen(); 这个地方未定义是会报错，所以我写成了  that.ws.onopen = function() {console.log('开始连接')};
    //     that.ws.onclose = function (event) {
    //       console.log('WebSocket connection closed with close code: ' + event.code + ',reason: ' + event.reason);
    //       // 关闭 websocket
    //       that.websocket.connectState = false;
    //       console.log('连接已关闭...');
    //       that.reconnect(event)
    //     };
    //     that.ws.onerror = function (event) {
    //       console.log('WebSocket error observed:', event);
    //       // 处理错误后可以选择重连
    //       that.websocket.connectState = false;
    //       // that.reconnect(); // 尝试重连
    //     }
    //   } else {
    //     // 浏览器不支持 WebSocket
    //     console.log('您的浏览器不支持 WebSocket!')
    //     this.isWs = false;
    //   }
    // },
    // reconnect() {
    //   if (!this.websocket.connectState) {
    //       let _this = this;
    //       let i = _this.count % _this.websocket.reconnectTimes.length; // 使用数组长度
    //       let t = 1000 * _this.websocket.reconnectTimes[i]; // 获取当前重连间隔
    //       console.log(new Date() +"第" + _this.count + "次重连,间隔时间" + _this.websocket.reconnectTimes[i] + "秒");
    //       _this.count++;
    //       setTimeout(() => {
    //         _this.localSocket(); // 在指定时间后尝试重连
    //       }, t);
    //     }
    // },
    menu_height() {
      if (this.$refs.pageHeader)
        this.set_menu_height({
          height: window.innerHeight - this.$refs.pageHeader.offsetHeight,
          tableHeight: window.innerHeight - 140
        })
    }
  },
}
</script>

<style>
*::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #b8b8b8;
  -webkit-border-radius: 6px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 4px solid #fff;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5;
}

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track-piece {
  background-color: #fff;
  -webkit-border-radius: 0;
}
</style>
